import React, { useMemo, useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { useTable, usePagination, useSortBy, useExpanded, useResizeColumns, useFlexLayout, useRowSelect } from "react-table";
import { QueryClient, QueryClientProvider, useQuery } from 'react-query'
import SortIcon from 'mdi-react/SortIcon';
import SortAscendingIcon from 'mdi-react/SortAscendingIcon';
import SortDescendingIcon from 'mdi-react/SortDescendingIcon';
import ReactTablePagination from '@/shared/components/table/components/ReactTablePagination';
import { reducer, useEffectToDispatch, fetchApiData, initialState, TableFilter } from "@/shared/apiTableHelper"
import { useDispatch, sendFlashMessage } from "@/shared/components/flash"
import ApiErrorMessage from "@/shared/components/ApiErrorMessage"
import ChangeStatusModal from "@/containers/Users/components/ChangeStatusModal"
import {canLoginAs} from '@/shared/helpers'
import FilterForm from "./FilterForm";

import axios from "axios";
import {
    Container,
    Card,
    CardBody,
    Row,
    Col,
} from "reactstrap";

import { USERS_COLUMNS } from "./columns";
import AddProgramUserModal from './AddProgramUserModal'
import EditProgramUserModal from './EditProgramUserModal'
import { StatusFilter } from "../../components/StatusFilter";
import { fetchRoles } from "../../../../shared/apiHelper";
import ProgramBreadcrumb from '@/shared/components/ProgramBreadcrumb'
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import LoginAsModal from "./LoginAsModal";
import { IndeterminateCheckbox } from "@/shared/components/form/IndeterminateCheckbox";
import ResendInviteModal from "./ResendInviteModal";
import {setProgramAction} from '@/redux/actions/programActions';
import store from '@/containers/App/store';
import AlertPopup from "../../../../shared/components/modal/alertModal/AlertPopup";
import ConfirmPopup from "../../../../shared/components/modal/confirmModal/ConfirmPopup";
import MoveUserModal from "./MoveUserModal";

const queryClient = new QueryClient()

const DataTable = ({ program, organization }) => {
    const { programId } = useParams();
    const [roles, setRoles] = useState([]);
    const [filter, setFilter] = useState({ keyword: '', role_id: '', status: '', position_level: '' });
    const [useFilter, setUseFilter] = useState(false);
    const [selectedRoleId, setSelectedRoleId] = useState('');
    const flashDispatcher = useDispatch()
    const [trigger, setTrigger] = useState(Math.floor(Date.now() / 1000));
    const [loading, setLoading] = useState(false)
    const [isOpenAdd, setOpenAdd] = useState(false)
    const [isOpenEdit, setOpenEdit] = useState(false)
    const [selectedUser, selectUser] = useState(false)
    const [user, setUser] = useState(null)
    const [isChangeStatusOpen, setChangeStatusOpen] = useState(false)
    const [isLoginAsOpen, setLoginAsOpen] = useState(false)
    const [filteredData, setFilteredData] = useState([]);
    const [selectedRows, setSelectedRows] = React.useState([]);
    const [isResendInviteOpen, setResendInviteOpen] = useState(false)
    const [isAlertOpen, setIsAlertOpen] = useState(false)
    const [isOpenConfirm, setIsOpenConfirm] = useState(false)
    const [isMoveUserOpen, setMoveUserOpen] = useState(false)
    
    const history = useHistory();

    const UserMenuLinks = () => {
        return (
            <>
                <span className="btn btn-sm btn-primary" >Invite</span>
                <span className="btn btn-sm btn-primary" onClick={() => history.push(`/program/${programId}/users/bulk-status-change`)} >Bulk Status Change</span>
                <span className="btn btn-sm btn-primary" onClick={() => history.push(`/program/${programId}/users/bulk-reclaim`)}>Bulk Reclaim Points</span>
                <span className="btn btn-sm btn-primary" onClick={() => onClickResendInvite(allSelcetedRows)} >Resend Invite</span>
            </>
        )
    }

    const toggleAdd = () => {
        setOpenAdd(prevState => !prevState)
    }
    const toggleEdit = () => {
        setOpenEdit(prevState => !prevState)
    }
    const toggleChangeStatus = () => {
        setChangeStatusOpen(prevState => !prevState)
    }
    const toggleMoveUser = () => {
        setMoveUserOpen(prevState => !prevState)
    }
    const onClickEditUser = (user_id) => {
        toggleEdit();
        selectUser(user_id);
    }
    const onClickMoveUser = (user) => {
        setUser(user);
        toggleMoveUser();
    }
    const toggleLoginAs = () => {
        setLoginAsOpen(prevState => !prevState)
    }
    const onClickLoginAs = user => {
        setUser(user);
        toggleLoginAs();
    }
    const toggleResendInvite = () => {
        setResendInviteOpen(prevState => !prevState)
    }
    const onClickResendInvite = (user) => {
        setSelectedRows(user);
        toggleResendInvite();
    }
    const alertToggle = () => {
        setIsAlertOpen(prevState => !prevState)
    }
    const toggleConfirm = (user) => {
        setUser(user)
        setIsOpenConfirm(prevState => !prevState)
    }
    const onClickRemoveUser = (user_id) => {
        if (!window.confirm('Are you sure to remove this user from this program?')) {
            return;
        }
        axios.delete(`/organization/${program.organization_id}/user/${user_id}/program/${program.id}`)
            .then((res) => {
                if (res.status === 200) {
                    flashDispatcher(sendFlashMessage('User removed successfully!', 'alert-success'))
                    setTrigger(Math.floor(Date.now() / 1000))
                }
            })
            .catch(error => {
                flashDispatcher(sendFlashMessage(<ApiErrorMessage errors={error.response.data} />, 'alert-danger'))
                console.log(error.response.data);
            })
    }

    const onClickResetPassword = (user) => {
        if (!window.confirm(`Are you sure you want to send a password reset email to ${user.email}?`)) {
            return;
        }
        axios.post(`/organization/${program.organization_id}/program/${program.id}/user/${user.id}/resetPassword`)
            .then((res) => {
                if (res.status === 200) {
                    flashDispatcher(sendFlashMessage('Password reset email sent successfully!', 'alert-success'))
                }
            })
            .catch(error => {
                flashDispatcher(sendFlashMessage(<ApiErrorMessage errors={error.response.data} />, 'alert-danger'))
                console.log(error.response.data);
            })
    }

    const RenderActions = ({ row }) => {
        const isUserRoleAllowed = roles.some(userRole =>
            row.original.roles.some(opt => opt.value === userRole.id)
        );
        return (
            <>
                <Link className="link a" to={`/program/${program.id}/user/view/${row.original.id}`}>View</Link>{' | '}
                <span onClick={() => onClickEditUser(row.original.id)} className="link a" >Edit</span>{' | '}
                <span onClick={() => onClickRemoveUser(row.original.id)} className="link a" >Unassign</span>
                {canLoginAs(program) && <> | <span onClick={() => onClickLoginAs(row.original)} className="link a" >Log In as</span></>}
                {isUserRoleAllowed && row.original.status.status === 'Pending Activation' && (
                    <> | <span onClick={() => onClickResendInvite([row.original])} className="link a" >Resend Invite
                    </span></>)
                }
                {!['Pending Activation', 'Deactivated'].includes(row.original.status.status) && (
                    <> | <span onClick={() => onClickResetPassword(row.original)} className="link a" >Reset Password</span></>)
                }{' | '}
                <span onClick={() => onClickMoveUser(row.original)} className="link a" >Move</span>
            </>
        )
    }

    const onClickStatus = user => {
        setUser(user);
        toggleChangeStatus()
    }
    const defaultContact = (user) => {
        axios.put(`/organization/${program.organization_id}/program/${program.id}/user/${user.id}/default-contact`)
            .then((res) => {
                if (res.status === 200) {
                    toggleConfirm();
                    flashDispatcher(sendFlashMessage('User has been set as default contact in the program!', 'alert-success'))
                    setTrigger(Math.floor(Date.now() / 1000))
                    program.default_contact_id = user.id
                    store.dispatch(setProgramAction(program))
                }
            })
            .catch(error => {
                flashDispatcher(sendFlashMessage(<ApiErrorMessage errors={error.response.data} />, 'alert-danger'))
                console.log(error.response.data);
            })
    }
    const onClickDefaultContact = (user, isDefaultContact) => {
        if (isDefaultContact) {
            alertToggle();
        } else {
            toggleConfirm(user);
        }
    }

    const strShowUserStatus = user => {
        return user?.status?.status ? <span onClick={() => onClickStatus(user)} className={'link'}>{user.status.status}</span> : 'unknown'
    }

    let user_columns = [
        {
            id: "selection",
            Header: ({ getToggleAllRowsSelectedProps }) => (
                <div className="d-flex ml-1">
                    <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
                </div>
            ),
            Cell: ({ row }) => (
                <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
            ),
            width: 35,
        },
        ...USERS_COLUMNS,
        ...[{
            Header: "",
            accessor: "action",
            Cell: ({ row }) => <RenderActions row={row} />,
            width: 250,
        }],
    ]
    user_columns.forEach((column, i) => {
        if (column.Header === 'Status') {
            user_columns[i].Cell = ({ row, value }) => { return strShowUserStatus(row.original) }
        }
        if (column.Header === 'Default Contact') {
            user_columns[i].Cell = ({ row }) => (
                <span onClick={() => onClickDefaultContact(row.original, program.default_contact_id === row.original.id)} className={'link'}>
                    {program.default_contact_id === row.original.id ? "Yes" : "No"}
                </span>
            )
        }
    })
    let columns = useMemo(() => user_columns, [roles])



    const defaultColumn = React.useMemo(
        () => ({
            minWidth: 30,
            width: 150,
            maxWidth: 400,
        }),
        []
    )

    const [{ queryPageIndex, queryPageSize, totalCount, queryPageFilter, queryPageSortBy, queryTrigger }, dispatch] = React.useReducer(reducer, initialState);

    const apiUrl = `/organization/${program.organization_id}/program/${program.id}/user`;

    useEffect(() => {
        const newFilter = { ...filter, role_id: selectedRoleId };
        setFilter(newFilter);
        console.log("filter", newFilter);
    }, [selectedRoleId]);

    const { isLoading, error, data, isSuccess } = useQuery(
        ['users', queryPageIndex, queryPageSize, queryPageFilter, queryPageSortBy, queryTrigger, selectedRoleId],
        () => fetchApiData(
            {
                url: apiUrl,
                page: queryPageIndex,
                size: queryPageSize,
                filter,
                sortby: queryPageSortBy,
                trigger: queryTrigger
            }),
        {
            keepPreviousData: true,
            staleTime: Infinity,
            onSuccess: () => {
                console.log('Data fetching success, data:', data);
            }
        }
    );

    useEffect(() => {
        if (program) {
            getRoles();
        }
    }, [program]);

    const getRoles = () => {
        setLoading(true);
        fetchRoles(organization.id, true)
            .then(data => {
                const formattedRoles = data.map(role => ({
                    value: role.id,
                    label: role.name
                }));
                setRoles(formattedRoles);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching roles:", error);
                setLoading(false);
            });
    };

    const totalPageCount = Math.ceil(totalCount / queryPageSize)

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        page,
        pageCount,
        pageOptions,
        gotoPage,
        previousPage,
        canPreviousPage,
        nextPage,
        canNextPage,
        setPageSize,
        selectedFlatRows,
        state: { pageIndex, pageSize, sortBy },
    } = useTable({
        columns,
        data: useMemo(() => (data ? data?.results : []), [data]),
        initialState: {
            pageIndex: queryPageIndex,
            pageSize: queryPageSize,
            sortBy: queryPageSortBy,
        },
        manualPagination: true,
        pageCount: data ? totalPageCount : 0,
        autoResetSortBy: false,
        autoResetExpanded: false,
        autoResetPage: false,
        defaultColumn,

    },
        useSortBy,
        useExpanded,
        usePagination,
        useResizeColumns,
        useFlexLayout,
        useRowSelect
    );
    const allSelcetedRows = selectedFlatRows.map((row) => row.original);

    const manualPageSize = []

    useEffectToDispatch(dispatch, { pageIndex, pageSize, gotoPage, sortBy, filter, data, useFilter, trigger });

    useEffect(() => {
        if (organization.id) {
            getRoles();
        }
    }, [organization.id]);

    const handleFilterChange = (newFilter) => {
        setFilter(newFilter);
        setUseFilter(true);
    };

    const handleRoleChange = (newRoleId) => {
        const newFilter = { ...filter, role_id: newRoleId };
        setFilter(newFilter);
        setUseFilter(true); //Trigger re-fetch or re-render as necessary
    };

    if (error) {
        return <p>Error: {JSON.stringify(error)}</p>;
    }

    if (isLoading) {
        return <p>Loading...</p>;
    }

    if (isSuccess)
        return (
            <>           
                <AlertPopup isOpen={isAlertOpen} title="Verify default contact" message="User is a default contact already" toggle={alertToggle} />
                <ConfirmPopup isOpen={isOpenConfirm} toggle={toggleConfirm} action={() => defaultContact(user)}
                    message={`Are you sure to set this user as default contact in program!`} />

                <div className='table react-table'>
                    <div className="form form--horizontal">
                        <div className="row m-0" style={{ width: '100%', alignItems: 'center' }} >
                            <div className="col-md-10 col-lg-10 d-flex align-items-center p-0">
                                <FilterForm
                                    onClickFilterCallback={handleFilterChange}
                                    roles={roles}
                                    filter={filter}
                                    organization={organization}
                                    program={program}
                                />
                            </div>
                            <div className="col-md-2 col-lg-2 d-flex justify-content-end align-items-center p-0">
                                <span
                                    className="btn btn-sm btn-primary account__btn account__btn--small mb-0 px-1"
                                    style={{ marginLeft: '12px' }}
                                    onClick={()=>toggleAdd()}
                                >Add Program User
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="pb-4 ">
                        <UserMenuLinks />
                    </div>
                    <AddProgramUserModal organization={organization} program={program} isOpen={isOpenAdd} setOpen={setOpenAdd} toggle={toggleAdd} setTrigger={setTrigger} />
                    <EditProgramUserModal organization={organization} program={program} userid={selectedUser} isOpen={isOpenEdit} setOpen={setOpenEdit} toggle={toggleEdit} setTrigger={setTrigger} />
                    {user && <ChangeStatusModal isOpen={isChangeStatusOpen} toggle={toggleChangeStatus} setTrigger={setTrigger} user={user} />}
                    {user && <LoginAsModal isOpen={isLoginAsOpen} toggle={toggleLoginAs} {...{ user, program }} />}
                    {user && <ChangeStatusModal isOpen={isChangeStatusOpen} setOpen={setChangeStatusOpen} toggle={toggleChangeStatus} setTrigger={setTrigger} user={user} />}
                    {!!selectedRows.length && <ResendInviteModal isOpen={isResendInviteOpen} setOpen={setResendInviteOpen} toggle={toggleResendInvite} {...{ selectedRows, program, setTrigger }} />}
                    {user && <MoveUserModal isOpen={isMoveUserOpen} toggle={toggleMoveUser} {...{ user, program, setTrigger }} />}
                    <table {...getTableProps()} className="table">
                        <thead>
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                            {column.render('Header')}
                                            {column.isSorted ? <Sorting column={column} /> : ''}
                                            <div
                                                {...column.getResizerProps()}
                                                className={`resizer ${column.isResizing ? 'isResizing' : ''
                                                    }`}
                                            />
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody className="table table--bordered" {...getTableBodyProps()}>
                            {page.map(row => {
                                prepareRow(row);
                                const subCount = (row.id.match(/\./g) || []).length
                                return (
                                    <tr {...row.getRowProps()}>
                                        {
                                            row.cells.map(cell => {
                                                const paddingLeft = subCount * 20
                                                return <td {...cell.getCellProps()}><span style={cell.column.Header === '#' ? { paddingLeft: `${paddingLeft}px` } : null}>{cell.render('Cell')}</span></td>
                                            })
                                        }
                                    </tr>
                                )
                            })}
                        </tbody>

                    </table>
                </div>
                {(rows.length > 0) && (
                    <>
                        <ReactTablePagination
                            page={page}
                            gotoPage={gotoPage}
                            previousPage={previousPage}
                            nextPage={nextPage}
                            canPreviousPage={canPreviousPage}
                            canNextPage={canNextPage}
                            pageOptions={pageOptions}
                            pageSize={pageSize}
                            pageIndex={pageIndex}
                            pageCount={pageCount}
                            setPageSize={setPageSize}
                            manualPageSize={manualPageSize}
                            dataLength={totalCount}
                        />
                        <div className="pagination justify-content-end mt-2">
                            <span>
                                Go to page:{' '}
                                <input
                                    type="number"
                                    value={pageIndex + 1}
                                    onChange={(e) => {
                                        const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                        gotoPage(page);
                                    }}
                                    style={{ width: '100px' }}
                                />
                            </span>{' '}
                            <select
                                value={pageSize}
                                onChange={(e) => {
                                    setPageSize(Number(e.target.value));
                                }}
                            >
                                {[10, 20, 30, 40, 50].map((pageSize) => (
                                    <option key={pageSize} value={pageSize}>
                                        Show {pageSize}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </>
                )}
            </>
        )
}

const Sorting = ({ column }) => (
    <span className="react-table__column-header sortable">
        {column.isSortedDesc === undefined ? (
            <SortIcon />
        ) : (
            <span>
                {column.isSortedDesc
                    ? <SortAscendingIcon />
                    : <SortDescendingIcon />}
            </span>
        )}
    </span>
);

const TableWrapper = ({ program, organization }) => {
    return (
        <QueryClientProvider client={queryClient}>
            <DataTable program={program} organization={organization} />
        </QueryClientProvider>
    )
}

const ProgramUsers = ({ organization }) => {
    const { programId } = useParams();
    const [program, setProgram] = useState(null);
    const fetchProgramData = async (organization) => {
        try {
            // ICOV3-1292: opt into root-fallback so the Login As modal shows the
            // root program's domains when this sub-program has none of its own.
            const response = await axios.get(`/organization/${organization.id}/program/${programId}`, {
                params: { withDomainFallback: true }
            });
            setProgram(response.data)
        } catch (e) {
            throw new Error(`API error:${e?.message}`);
        }
    };
    useEffect(() => {
        if (organization) {
            fetchProgramData(organization)
        }
    }, [organization])

    if (!program?.id || !organization?.id) {
        return 'Loading...'
    }
    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 className="page-title">Program Users</h3>
                    <h3 className="page-subhead subhead"><Link className="" to="/">Home</Link> / <Link className="" to="/program">Programs</Link> <ProgramBreadcrumb program={program} linkSelf={true} /> / Users </h3>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <Card>
                        <CardBody>
                            {program && organization && <TableWrapper program={program} organization={organization} />}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}
export default withRouter(connect((state) => ({
    organization: state.organization
}))(ProgramUsers));
